// extracted by mini-css-extract-plugin
export default {"header":"offcanvas_header__l29TA","linksContainer":"offcanvas_linksContainer__o1rQt","link":"offcanvas_link__KgMBZ"};